import { useSelector } from "react-redux";
import { COVERAGE_TYPE_IDS, PRODUCT_TYPE_IDS } from "../../constant/gms-constant";
import { selectAmountOfLoans, selectLoanPortfolio, selectMaxAmount, selectMinAmount } from "../../features/gms-proposal-forms/amount-of-loans/amount-loans.slice";
import { selectIsLevelRankingComplete, selectIsSalaryRankComplete, selectIsUniformCoverageComplete } from "../../helper/proposal/proposal-is-complete-form-helper";
import { useProposalTypeData } from "../proposal/use-proposal-type-data";
import { selectBasicPlansState, selectCoverageTypeState, selectProductTypeState, selectProposalTypeState, selectPrototypeTypeState } from "../../features/gms-proposal-forms/types-proposal-product-basic-plan/types-proposal-product-basic-plan-slice";
import { borrowerAgeOptionsState } from "../../features/gms-proposal-forms/age-bracket-and-benefit-amount/age-bracket-and-benefit-amount.slice";
import { selectCommissionValueState, selectLoanMaturityMonthsState, selectPaymentTerm, selectServiceValueState } from "../../features/gms-proposal-forms/payment_term-loan_maturity-commission_services-notes-files/payment_term-loan_maturity-commission_services-notes-files.slice";
import { useToastify } from "../../library/toastify/toast-provider";

export const useSecondStepValidation = () => {

    const { showToastNotify } = useToastify();
    const { isPrototype, isCustomize } = useProposalTypeData()
    // const { isValidCoverageInputs } = useCoverageInputsValidation();
    // PROTOTYPE 
    const selectedPrototypeTypeState = useSelector(selectPrototypeTypeState);
    // CUSTOMIZE
    const selectedProposalTypeState = useSelector(selectProposalTypeState);
    const productType = useSelector(selectProductTypeState);
    const basicPlan = useSelector(selectBasicPlansState);
    const amountOfLoansChecked = useSelector(selectAmountOfLoans);
    // const amountOfLoansFAmount = useSelector(selectAmountOfLoansFAmount);
    const minAmount = useSelector(selectMinAmount);
    const maxAmount = useSelector(selectMaxAmount);
    const loanPortfolio = useSelector(selectLoanPortfolio);
    
    const coverageType = useSelector(selectCoverageTypeState);
    const isLevelRankingComplete = useSelector(selectIsLevelRankingComplete);
    const isUniformCoverageComplete = useSelector(selectIsUniformCoverageComplete);
    const isSalaryRankComplete = useSelector(selectIsSalaryRankComplete);

    const paymentTerm = useSelector(selectPaymentTerm);
    const loanMaturityMonths = useSelector(selectLoanMaturityMonthsState);
    // const borrowerAgeValues = useSelector(borrowerAgeValuesState);
    const borrowerAgeOption = useSelector(borrowerAgeOptionsState);
    const ageBracketList = borrowerAgeOption.filter(item => item.isShow);
    // const ageProfile1865Amount = useSelector(selectAgeProfileRateAmountState);
    // const ageProfile1865 = useSelector(selectAgeProfileRateState);
    const selectCommissionValue = useSelector(selectCommissionValueState);
    const selectServiceValue = useSelector(selectServiceValueState);
    // const requiredRate = isProductGCLI || isProductGYRT;



    // const validateBorrowerAgeSequence = () => {
    //     let foundFalse = false;

    //     for (const item of ageBracketList) {
    //         if (foundFalse && item.value === true) {
    //             showToastNotify( "Invalid borrower age selection: you cannot enable a higher age range after disabling a lower one.", "warning" );
    //             return false;
    //         }

    //         if (item.value === false) {
    //             foundFalse = true;
    //         }
    //     }

    //     return true;
    // };

    const isValidSecondStep = () => {
        if (!selectedProposalTypeState?.id) {
            showToastNotify("Select type of proposal.", "warning");
            return false;
        }
        if(isPrototype) {
            if (!selectedPrototypeTypeState?.id) {
            showToastNotify("Select type of prototype.", "warning");
            return false;
        }
        }
        if(isCustomize){
            if (!productType?.id) {
                showToastNotify("Select type of product.", "warning");
                return false;
            }
            if (!basicPlan?.id) {
                showToastNotify("Select type of basic plan.", "warning");
                return false;
            }
            // AMOUNT LOANS
            if(productType.id === PRODUCT_TYPE_IDS.GCLI) {
                if (!amountOfLoansChecked) {
                    showToastNotify("Select type of amount of loans.", "warning");
                    return false;
                }
                // if(!amountOfLoansFAmount) {
                //     showToastNotify("Enter loan amount.", "warning");
                //     return false;
                // }
                if(!minAmount) {
                    showToastNotify("Enter minimum amount of loan.", "warning");
                    return false;
                }
                if(!maxAmount) {
                    showToastNotify("Enter maximum amount of loan.", "warning");
                    return false;
                }
                if (Number(minAmount) > Number(maxAmount)) {
                    showToastNotify("Minimum amount of loan cannot be greater than the maximum amount.", "warning");
                    return false;
                }
                if(!loanPortfolio) {
                    showToastNotify("Enter loan portfolio.", "warning");
                    return false;
                }
                if(!paymentTerm?.id) {
                    showToastNotify("Select payment term.", "warning");
                    return false;
                }
                if(!loanMaturityMonths) {
                    showToastNotify("Enter number of months for loan maturity.", "warning");
                    return false;
                }
            }
            // COVERAGE
            if(productType.id === PRODUCT_TYPE_IDS.GPA || productType.id === PRODUCT_TYPE_IDS.GYRT) {
                if (!coverageType?.id) {
                    showToastNotify("Select coverage type.", "warning");
                    return false;
                }
                if (!coverageType.id) {
                    showToastNotify("Select coverage type.", "warning");
                    return false;
                }
                if(coverageType.id === COVERAGE_TYPE_IDS.levelRanking && !isLevelRankingComplete) {
                    showToastNotify("At least 2 rows are required and all fields must be completed.", "warning");
                    return false;
                }
                if(coverageType.id === COVERAGE_TYPE_IDS.salaryRank && !isSalaryRankComplete) {
                    showToastNotify("At least 2 rows are required and all fields must be completed.", "warning");
                    return false;
                }
                if(coverageType.id === COVERAGE_TYPE_IDS.uniformCoverage && !isUniformCoverageComplete) {
                    showToastNotify("Enter uniform coverage amount.", "warning");
                    return false;
                }
            }

            // BENEFITS AND RATES
            let foundFalse = false;

            for (const item of ageBracketList) {
                if (foundFalse && item.value === true) {
                    showToastNotify(
                        "Invalid borrower age selection: you cannot enable a higher age range after disabling a lower one.",
                        "warning"
                    );
                    return false;
                }

                if (item.value === false) {
                    foundFalse = true;
                }
            }
            // const hasValidValue = borrowerAgeValues.some(
            //     (val) => val == null
            // );
            // const invalidItem = ageBracketList.find((option) => {
            //     return option.value === true && !option.amount;
            // });
            // if(!ageProfile1865Amount) {
            //     showToastNotify(`${ageProfile1865.label} benefit amount is required`, "warning");
            //     return false;
            // }
            // if(requiredRate && hasValidValue) {
            //     showToastNotify("Please complete all rates.", "warning");
            //     return false;
            // }
            // if(requiredRate && invalidItem) {
            //     showToastNotify(`${invalidItem.label} benefit amount is required`, "warning");
            //     return false;
            // }
            // if (requiredRate) {
            //     if (!validateBorrowerAgeSequence()) return false;

            //     if (!ageProfile1865Amount) {
            //         showToastNotify(
            //             `${ageProfile1865.label} benefit amount is required`,
            //             "warning"
            //         );
            //         return false;
            //     }

            //     if (hasValidValue) {
            //         showToastNotify("Please complete all rates.", "warning");
            //         return false;
            //     }

            //     if (invalidItem) {
            //         showToastNotify(
            //             `${invalidItem.label} benefit amount is required`,
            //             "warning"
            //         );
            //         return false;
            //     }
            // }
            // COMMISSION AND SERVICE/COLLECTION RATE
            if (selectCommissionValue === null) {
                showToastNotify("Enter commission rate.", "warning");
                return false;
            }
            if (!selectServiceValue === null) {
                showToastNotify("Enter service/collection fee.", "warning");
                return false;
            }
        }

        return true
    }

    return { 
        isValidSecondStep, 
    }
};